import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

const PROTECTED_PREFIXES = ["/admin", "/centrale", "/espace-client", "/partenaire", "/entreprise", "/acces-phase3"];

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  const location = useLocation();

  // /auth/me n'est utile que sur les routes authentifiées (JWT cookie) : on évite l'appel
  // (et le 401 dans la console) pour tous les visiteurs des pages publiques.
  useEffect(() => {
    if (!PROTECTED_PREFIXES.some((p) => location.pathname.startsWith(p))) return;
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => setUser(false));
  }, [location.pathname]);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    setUser(res.data);
    return res.data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setUser(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
